/* istanbul ignore file */
import Settings from '../../utils/Settings';

export const settings = new Settings();
